import { ViewFactory } from 'wdc-cube-react'
import SerasaHistoryScope, { HeaderScope } from '../serasa-history.scopes'
import HeaderView from './serasa-history.header'
import SerasaHistoryView from './serasa-history.view'

export function registerViews(rv = ViewFactory.register) {
    rv(SerasaHistoryScope, SerasaHistoryView)
    rv(HeaderScope, HeaderView)
}
